import { mdiStarOutline, mdiStar, mdiStarHalfFull } from '@mdi/js'

export const EVENT_STAR_CONFIG = {
  emptyIcon: mdiStarOutline,
  fullIcon: mdiStar,
  halfIcon: mdiStarHalfFull,
  length: 5,
  size: 24,
  color: 'var(--color-gold-900)',
  backgroundColor: 'var(--color-gold-900)',
  class: 'star',
}
